import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import R from 'ramda';

import styles from './select.css';

const { div, select, option } = hh(h);

const Select = (props) => (
    div({className: styles.container}, [
        select(
            {
                id: props.id,
                className: styles.select,
                value: props.value,
                required: props.required,
                onChange: (event) => props.onChange(event.target.value),
                readOnly: props.readonly
            },
            R.map(
                ({label, value}) => option({id: props.id, className: styles.option, value}, label),
                props.options.enumOptions)
        )])
);

export default Select;



/** WEBPACK FOOTER **
 ** ./src/ApplicationForm/Select.js
 **/